import {
  Box,
  Grid2,
  TextField,
  Typography,
  Alert,
  InputAdornment,
} from "@mui/material";
import { DimensionsProps } from "./types";
import { useTranslation } from "../../../../../hooks/useTranslation";

export const DimensionsSection = ({
  dimensions,
  units,
  onChange,
  isPositiveNumber,
}: DimensionsProps) => {
  const { translate } = useTranslation("pages.orderDetails.prepareShipment");

  return (
    <Box>
      <Alert severity="info" sx={{ mb: 2 }}>
        {translate("usingEstimatedDimensions")}
      </Alert>

      <Typography variant="subtitle1" fontWeight="bold" mb={1}>
        {translate("packageDimensions")}
      </Typography>

      <Grid2 container spacing={2}>
        {(["length", "width", "height", "weight"] as const).map((field) => (
          <Grid2 size={6} key={field}>
            <TextField
              fullWidth
              size="small"
              type="number"
              label={translate(field)}
              value={dimensions[field]}
              error={!isPositiveNumber(dimensions[field])}
              onChange={(e) => onChange(field, e.target.value)}
              slotProps={{
                htmlInput: { step: 0.1, min: 0 },
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      {units[field]}
                    </InputAdornment>
                  ),
                },
              }}
            />
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
};
